import { createApp, h } from 'vue'
import AlertComponent from './Alert.vue'

function useToast() {
  const showToast = (message: string, ms: number = 3000) => {
    const alertApp = createApp({
      render() {
        return h(AlertComponent, { message })
      },
    })

    const mountNode = document.createElement('div')
    document.body.appendChild(mountNode)

    alertApp.mount(mountNode)

    // Automatically unmount and remove the component from the DOM after a delay
    setTimeout(() => {
      alertApp.unmount()
      document.body.removeChild(mountNode)
    }, ms) // Adjust the delay as needed
  }

  return {
    showToast,
  }
}

export default useToast
